import {ProductPageTabCustomerPhotosAndMedia} from './MediaPhotos/Tab3MediaComponent.jsx';
import {buildBoxInfoTab, buildBundleComponentItemsTab, buildInstallInfoTab} from './TabHelpers.jsx';

export const buildTabs3and4 = (sku, metaData, category, tabMedia, product, variants) => {
  // console.log('[buildTabs3and4] sku: ', sku);
  // console.log('[buildTabs3and4] category: ', category);
  // console.log('[buildTabs3and4] product: ', product);
  let skuList = variants?.map((x) => x?.sku);
  const productType = product?.product_type;
  if (productType === 'normal') {
    skuList = [sku];
  }
  let tabNames = [];
  let tabsData = [];

  const addTab = (name, data) => {
    tabNames.push(name);
    tabsData.push(data);
  };

  const addPhotosTab = () => {
    addTab('Media',
      <ProductPageTabCustomerPhotosAndMedia sku={sku} skuList={skuList} />
    );
  };

  switch (category) {
    case 'amplifiers':
      addPhotosTab();
      break;
    case 'custom-bundle':
      if (tabMedia?.length > 0) {
        ['Bundle Items (What\'s Included)', 'Specifications', 'Media'].forEach((name) =>
          tabNames.push(name)
        );
        tabsData.push(...buildBundleComponentItemsTab(product),
          <ProductPageTabCustomerPhotosAndMedia sku={sku} skuList={skuList} />
        );
      }
      break;
    case 'subwoofers':
      addTab('Box Info', buildBoxInfoTab(metaData, sku));
      addPhotosTab();
      break;
    case 'marine-subwoofers':
      addTab('Box Info', buildBoxInfoTab(metaData, sku));
      addPhotosTab();
      break;
    case 'empty-subwoofer-enclosures':
      addTab('Box Info', buildBoxInfoTab(metaData, sku));
      addPhotosTab();
      break;
    case 'loaded-subwoofer-enclosures':
      addTab('Box Info', buildBoxInfoTab(metaData, sku));
      addPhotosTab();
      break;
    case 'speakers':
      addTab('Install', buildInstallInfoTab(metaData, sku));
      addPhotosTab();
      break;
    case 'complete-bass-package':
      if (metaData?.box_info) {
        addTab('Box Info', buildBoxInfoTab(metaData, sku));
      }
      addPhotosTab();
      break;
    default:
      // add photos tab if there are photos and no photos tab exists
      // because is not a special category listed above so that visitors
      // can see user submitted images.

      if (!tabNames?.length) {
        const tabNamesIncludesPhotos = tabNames?.includes('Photos');
        const tabNamesIncludesCustomerPhotos = tabNames?.includes('Media');
        if (!tabNamesIncludesPhotos && !tabNamesIncludesCustomerPhotos) {
          addPhotosTab();
        }
      }
      break;
  }

  return {
    tabNames3and4: tabNames,
    tabsData3and4: tabsData
  };
};
